<template>
  <div class="nzmFloatEntry" v-if="img && show" :style="wrap_style">
    <img class="img" :src="img" @click.prevent="click_item" />
    <img
      class="close"
      @click="close"
      src="https://vipcdn.mgtv.com/lego/20191231/lego/17bc3c422b9b11eaaaadfa163e9e1c06.png"
    />
  </div>
</template>
<script>
import Imgs from "./NzmImgScroll/Imgs";
import { getJSON, getJSONP } from "../../api/myaxios";
import { toRem, urlToWebp } from "../../tools/tpl";
import click_handler from "../../tools/mgtv/click";
import { openLink } from "../../tools/mgtv/link";
import handle_action from "../../tools/mgtv/action";

import { get_dynamic_entry } from "../../api/index";
import { report_urls, report } from "../../tools/mgtv/analysis";
import { onUseInfoLoad } from "../../tools/onUseInfoLoad";
import { getRandom } from '../../tools/random'

const configs = {
  m01: {
    style: {
      position: "fixed",
      width: "1.4rem",
      height: "1.4rem",
      bottom: "2rem",
      right: ".285rem"
    }
  },
  m02: {
    style: {
      position: "fixed",
      width: "6.93rem",
      height: "1.30rem",
      bottom: ".3rem",
      right: ".285rem"
    }
  }
};

export default {
  name: "NzmFloatEntry",
  components: {},
  props: {
    info: {
      type: Object
    }
  },
  data: function() {
    return {
      show: false,
      static_info: null, //哪吒配置
      dynamic_info: null //动态接口配置
    };
  },
  methods: {
    click_item() {
      if (this.static_info) {
        const item = this.static_info;
        click_handler(
          `${this.info.act_name_chn}-点击-${item.id}`,
          () => {
             handle_action(item);
          },
          {
            need_act: item.action_info.need_act,
            need_login: item.action_info.need_login,
            need_new_user: item.action_info.need_new_user
          }
        );
      } else if (this.dynamic_info) {
        click_handler(`${this.info.act_name_chn}-点击`, () => {
          report(this.dynamic_info.click_report_urls);
          openLink(this.dynamic_info.jump_url);
        });
      }
    },
    close() {
      this.show = false;
      if (this.dynamic_info) {
        click_handler(`${this.info.act_name_chn}-关闭`, () => {
          report(this.dynamic_info.close_report_urls);
        });
      }
    },
    get_dynamic_info() {
      const entry_source = this.info.config.dynamic_entry_source;
      if (!entry_source) {
        return;
      }
      get_dynamic_entry(entry_source).then(res => {
        /**
       * {
            status: "200",
            msg: "",
            seqid: "77e6496098394a07abbe582245fce529",
            data: {
                click_report_urls: [
                "https://vip.log.mgtv.com/dynamic_entry.html?source=main_chn_pop&invoker=mobile-zhifubao&version=6.9.9_vipact&did=0000-0000-0000&uuid=&vid=&cid=&chnid=&plid=&plan_id=116&exp=&creativity_id=116&type=click"
                ],
                disp_tm: 5,
                show_report_urls: [
                "https://vip.log.mgtv.com/dynamic_entry.html?source=main_chn_pop&invoker=mobile-zhifubao&version=6.9.9_vipact&did=0000-0000-0000&uuid=&vid=&cid=&chnid=&plid=&plan_id=116&exp=&creativity_id=116&type=show"
                ],
                content: "https://vipcdn.mgtv.com/act_ugc/billing/20200219/tmp/a6ccab2252d511eaa38000163e068bbe.png",
                close_report_urls: [
                "https://vip.log.mgtv.com/dynamic_entry.html?source=main_chn_pop&invoker=mobile-zhifubao&version=6.9.9_vipact&did=0000-0000-0000&uuid=&vid=&cid=&chnid=&plid=&plan_id=116&exp=&creativity_id=116&type=close"
                ],
                jump_url: "https://www.baidu.com",
                type: 0 //图片
            }
          }
       */
        if (!res) {
          return;
        }
        if (res.status === "200") {
          if (res.data.type === 0) {
            this.dynamic_info = res.data;
            this.show = true;
            report_urls(this.dynamic_info.show_report_urls);

            //自动关闭
            if (this.dynamic_info.disp_tm && this.dynamic_info.disp_tm > 0) {
              setTimeout(() => {
                this.show = false;
              }, this.dynamic_info.disp_tm * 1000);
            }
          }
        }
      });
    },
    get_static_asset() {
      getJSON(
        "//vipact3.api.mgtv.com/api/v1/act/img/get",
        {
          act_name: this.info.act_name,
          invoker: window.gact.invoker,
          f_release: window.gact.f_release
        },
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          const list = res.data.list;
          if (list.length <= 0) {
            return;
          }

          const random_id = getRandom(0, list.length - 1);
          const choose_item = list[random_id];
          choose_item.img = urlToWebp(choose_item.img);

          this.static_info = choose_item
          this.show = true;

        }
      });
    },
    get_detail() {
      if (this.info.config.dynamic_entry_source) {
        onUseInfoLoad(() => {
          this.get_dynamic_info();
        }, false);
      } else {
        this.get_static_asset();
      }
    }
  },
  computed: {
    show_type: function() {
      return this.info.config.show_type || "m01";
    },
    wrap_style() {
      return configs[this.show_type].style;
    },
    img() {
      if (this.dynamic_info) {
        return urlToWebp(this.dynamic_info.content);
      } else if (this.static_info) {
        return this.static_info.img;
      }
    }
  },
  mounted() {
    this.get_detail();
  }
};
</script>


<style lang="stylus"  >
.nzmFloatEntry
    position absolute
    z-index 100
    .img
      position relative
      display block
      width 100%
      height 100%
    .close
      position absolute
      top  -.4rem
      right 0rem
      padding .1rem
      width .5rem
      height @width
</style>
